import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { addFuelType, getSingleFuelType, updateFuelType } from '../../../actions/homeAction'

const FuelTypeAdd = () => {
  const [fuelType, setFuelType] = useState({
    fuelType:'',
    fuelTypeAr:'',
    priority: null,
    active: true
  })
  const [dataEdit, setDataEdit] = useState(false)

const {ftUUID} = useParams()

const dispatch = useDispatch()

const location = window.location.href.split('/')[6]

useEffect(() => {
  if(location === 'Update'){
    dispatch(getSingleFuelType(ftUUID))
    setDataEdit(true)
  } else {
    setDataEdit(false)
  }
},[])

const singleFuelType = useSelector(state => state.home.singleFuelType)?.response
const data = singleFuelType

useEffect(() => {
  setFuelType({
    fuelType: data?.fuelType,
    fuelTypeAr: data?.fuelTypeAr,
    priority: data?.priority,
    active: data?.active === 0 ? 'false' : 'true'
  })
},[data?.fuelType])

console.log("fuelType", ftUUID);
  const onChangeHandle = (e) => {
    const {name, value} = e.target
    setFuelType({...fuelType, [name]:value})
  }
  
  
  const onSave = () => {
    if(dataEdit){
      const payload = {
        fuelType:fuelType.fuelType,
        fuelTypeAr:fuelType.fuelTypeAr,
        priority:fuelType.priority,
        active: fuelType.active,
        fuelTypeId: data.fuelTypeId
        }
        dispatch(updateFuelType(payload))
      } else {
        dispatch(addFuelType(fuelType))
    }
  }

  return (
    <div className='main-body'>
    <div className='page-wrapper'>
      <div className='page-header'>
        <div className='row align-items-end'>
          <div className='col-lg-8'>
            <div className='page-header-title'>
              <div className='d-inline'>
                <h4>
                  { dataEdit ? `Edit : ${fuelType?.fuelType}` : "Add Fuel Type" } 
                </h4>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='page-header-breadcrumb'>
              <ul className='breadcrumb-title'>
                <li className='breadcrumb-item'>
                  <Link to='/'>
                    <i className='feather icon-home'></i>{' '}
                  </Link>
                </li>
                <li className='breadcrumb-item'>
                  <Link to='/CarDetail/FuelType'>Fuel Type</Link>
                </li>
                <li className='breadcrumb-item active'>
                { dataEdit ? "Edit Fuel Type:" : "Add Fuel Type" } 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='page-body'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='card card-border-default'>
              <div className='card-block'>
                
                <div className='tab-content tabs'>
                  <div
                    className='tab-pane  active'
                    id={'car_user_'}
                    role='tabpanel'
                    aria-labelledby=''>
                      <div className=''>
        	<div className='col-md-6'>
							
						</div>

        {/* sdjkfj */}
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Fuel Type Name</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='fuelType'
										value={fuelType.fuelType}
										placeholder='Fuel Type Name'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Fuel Type Name Ar</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='fuelTypeAr'
										value={fuelType.fuelTypeAr}
										placeholder='Fuel Type Name Ar'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>

              <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Priority</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    name='priority'
                                    value={fuelType.priority}
                                    placeholder='Priority'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
						
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='active'
										className='form-control'
										onChange={onChangeHandle}
										value={fuelType?.status}
                    >
										<option value={true} name='active'>
											Active
										</option>
										<option value={false} name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						<div className='row float-right p-3'>
							
							<button
								onClick={onSave}
								className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> {dataEdit ? 'Update' : 'Save'}
							</button>
							<Link to={'/CarDetail/FuelType'} className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default FuelTypeAdd